export default {
    /* ********************************************营销活动报名************************************* */
    //  商品sku列表
    findPromotionByItemId: "promotion/mgmt/getPromotionSkuGoodsList",
    //  报名列表
    getPlatformEnrolPromotionList: "/promotion/mgmt/getPlatformEnrolPromotionList",
    //  店铺等级
    selecMerchantGradeByName: "/merchant/merchantGrade/selecMerchantGradeByName",
    //  活动列表
    getEnrolPromotionList: "/promotion/mgmt/getEnrolPromotionList",
    //  发起报名
    editInitiateEnrol: "/promotion/mgmt/editInitiateEnrol",
    //  审核列表
    getPromotionEnrolStoreList: "/promotion/mgmt/getPromotionEnrolStoreList",
    //  店铺不通过
    editStoreAuditNonconformity: "/promotion/mgmt/editStoreAuditNonconformity",
    //  获取报名店铺信息
    getPromotionEnrolStore: "/promotion/mgmt/getPromotionEnrolStore",
    //  报名店铺商品信息
    getStoreGoodsAuditList: "/promotion/mgmt/getStoreGoodsAuditList",
    //  审核sku
    editAuditSingleSkuGoods: "/promotion/mgmt/editAuditSingleSkuGoods",
    //  审核sku完成
    editAuditSkuGoods: "/promotion/mgmt/editAuditSkuGoods",
    //  审核商品是否通过
    editAuditItemGoods: "/promotion/mgmt/editAuditItemGoods",
    //  全部审核完成
    editAuditGoods: "/promotion/mgmt/editAuditGoods",
    //  新优惠券增加
    addCouponActivity: "/promotion/CouponActivity/addCouponActivity",

    /********************************************* 营销活动管理 *****************************************/
    mixedManage: {
        getPromotionList: '/promotion/platform/common/getPromotionList',//活动列表
        getBasic: '/promotion/platform/multi/getBasic/',//获取活动基本信息
        addPromotion: '/promotion/platform//multi/addPromotion',//新增活动
        editPromotion: '/promotion/platform/multi/editPromotion',//编辑活动

        getApplyConfigure: '/promotion/apply/platform/getApplyConfigure/',//获取报名配置信息
        editApplyLimitType: '/promotion/apply/platform/editApplyLimitType',//编辑限制类型下的限制条件

        getCategoryBrands: '/goods/brand/getCategoryBrands',//获取品牌可选列表
        getAllApplyBrands: '/promotion/apply/platform/getAllApplyBrands/',//获取已配置的报名品牌
        saveApplyBrands: '/promotion/apply/platform/saveApplyBrands',//批量添加报名的品牌
        removeApplyBrands: '/promotion/apply/platform/removeApplyBrands',//批量移除报名的品牌

        getStoreBackcatetory: '/merchant/storeInfo/getStoreBackcatetory',//获取可选的店铺列表
        getAllApplyStores: '/promotion/apply/platform/getAllApplyStores/',//获取已选的店铺列表
        saveApplyStores: '/promotion/apply/platform/saveApplyStores',//批量添加报名的店铺
        removeApplyStores: '/promotion/apply/platform/removeApplyStores',//批量移除报名的店铺

        getListLevelBackendCategory: '/goods/category/getCategory',//类目可选列表
        getBatchApplyCategorys: '/promotion/apply/platform/getBatchApplyCategorys',//获取类目的已选列表
        saveApplyCategory: '/promotion/apply/platform//saveApplyCategory',//批量添加类目
        removeApplyCategory: '/promotion/apply/platform/removeApplyCategory',//移除已选类目

        saveApply: '/promotion/apply/platform/save',//报名后的发布保存
        remove: '/promotion/apply/platform/remove/',//取消活动

        getApplyList: '/promotion/audit/platform//getApplyList',//商家报名列表
        getApplyGoods: '/promotion/audit/platform/getApplyGoods',//商家商品报名列表（待审核）
        getActivityApplyGoods: '/promotion/audit/platform/getActivityApplyGoods',//商家商品报名列表（已通过）
        selectApplyGoods: '/promotion/audit/platform/selectApplyGoods',//商家商品报名商品列表（已审核）
        getShowSkuList: '/promotion/audit/platform/getShowSkuList/',//商家商品报名SKU列表
        passMerchantApply: '/promotion/audit/platform/passMerchantApply',//审核通过 完成

        getLogList: '/promotion/platform/common/getLogList/',//活动日志
        removePromotion: '/promotion/platform/common/removePromotion/',//删除活动
        copyPromotion: '/promotion/platform/common/copyPromotion/',//复制活动
        stopPromotion: '/promotion/platform/common/stopPromotion',//停止活动

        addPromotionSeck: "/seckilling/promotion/addPromotion",  //新增秒殺
        sessionsSecondkill: "/seckilling/promotion/find/seckilling/sessions/", /*获取场次 */
        sikkllEditPromotion:"/seckilling/promotion/editPromotion",  /* 編輯活動 */
        sessionName:"/seckilling/promotion/update/session/name",    /* 编辑场次名称 */
        removeGoods:"/seckilling/promotion/rollback/goods", /* 删除场次商品 */
        seckillGoods:"/seckilling/promotion/can/choose/goods",  /* 可选商品列表 */
        storGoods:"/seckilling/promotion/sort/good",/* 排序商品 */
        chooseGoods:"/seckilling/promotion/had/choose/goods",   /* 场次已选商品列表 */
        commitGoods:"/seckilling/promotion/commit/goods",   /* 增加商品 */
        sessionSaveGoods:"/seckilling/promotion/session/goods/save/",    //场次商品排序后保存
        getAllApplySkuList: '/seckilling/promotion/getAllApplySkuList', //sku报名配置列表
        getSystemTime:"/promotion/common/getSystemTime",    /*獲取系統時間*/
        skillCopyPromotion:"/seckilling/promotion/copyPromotion/",  //复制活动
        skillRemovePromotion:"/seckilling/promotion/removePromotion/",  //刪除活動
        skillStopPromotion:"/seckilling/promotion/stopPromotion",   //停止活动

        drawAddPromotion:"/lottery/promotion/addPromotion", //新增抽奖·
        drawEditPromotion:"/lottery/promotion/editPromotion", //编辑抽奖
        drawFindPromotion:"/lottery/promotion/findPromotion/",    //查看活动详情
        drawList:"/lottery/promotion/promotion/list",    //查询活动列表
        drawDelete:"/lottery/promotion/delete/promotion/",  //删除活动
        drawStop:"/lottery/promotion/stop/promotion/",   //停止活动
        drawSave:"/lottery/promotion/save_release/", /*保存或发布 */
        drawChooseGoods:"/lottery/promotion/had/choose/goods",  //商品已选列表
        rollbackGoods:"/lottery/promotion/rollback/goods",  //刪除已选商品
        drawCanGoods:"/lottery/promotion/can/choose/goods", //商品可选列表
        addGoods:'/lottery/promotion/commit/goods',//添加商品
        goodsConfig:"/lottery/promotion/good/promotion/config", //商品參數配置
        drawFindLogs:"/promotion/autoGrant/coupon/findLogs/",    //操作纪录
        drawWinRecord:"/lottery/promotion/winning/record",  //中奖纪录



        /**会员礼品 */
        giftList:"/promotion/gift/promotion/list",  //获取列表
        giftStop:"/promotion/gift/stop/promotion/",    //停止活动
        giftRemovePromotion:"/promotion/gift/delete/promotion/", //删除活动
        giftAddPromotion:"/promotion/gift/addPromotion",    //新增活动
        giftEditPromotion:"/promotion/gift/editPromotion",   //编辑活动
        giftFindPromotion:"/promotion/gift/findPromotion/", //活动详情
        giftChooseGoods:"/promotion/gift/had/choose/goods", // 已选商品列表
        giftHadChooseGoods:"/promotion/gift/can/choose/goods",  //可选商品列表
        record:'/promotion/gift/winning/record',//中奖纪录
        giftRollbackGoods:"/promotion/gift/rollback/goods", //刪除商品
        giftCommitGoods:"/promotion/gift/commit/goods", //提交商品
        giftSave:"/promotion/gift/save_release/",   //保存发布
        giftPromotionConfig:"/promotion/gift/good/promotion/config",  //商品排序设置
        giftWinning:"/promotion/gift/download/winning/record/", //导出
        /* **拼团** */
        getGroupList: '/promotion/collage/platform/getList',/* 拼团活动列表 */
        collageGoodsList: '/promotion/collage/platform/record/getList',/* 拼团活动记录列表 */
        addCollagInfo: '/promotion/collage/platform/addCollagInfo',/* 创建拼团 */
        editCollage: '/promotion/collage/platform/editCollage',/* 修改拼团 */
        getCollage: '/promotion/collage/platform/getCollage/',/* 回显拼团基本信息 */
        getChoseTabApplyGoods:'/promotion/audit/platform/getChoseTabApplyGoods',/* 选择商品 弹框中的商品列表 */
        batchAddTabApplyGoods:'/promotion/audit/platform/batchAddTabApplyGoods',/* 添加商品 */
        batchRemoveTabApplyGoods:'/promotion/audit/platform/batchRemoveTabApplyGoods',/* 删除商品 */
        getCollageTabList:'/promotion/audit/platform/getCollageTabList/',/* 获取分类展示的tab */
        collageTabSwitchNoTab:'/promotion/audit/platform/collageTabSwitchNoTab/',/* 取消分类展示 */
        addCollageTab:'/promotion/audit/platform/addCollageTab',/* 添加分类展示tab */
        editCollageTab:'/promotion/audit/platform/editCollageTab',/* 编辑分类展示tab */
        getTabApplyGoods:'/promotion/audit/platform/getTabApplyGoods',/* 获取分类展示的商品列表 */
        removeCollageTab:'/promotion/audit/platform/removeCollageTab',/* 删除分类展示tab */
        getDetail:'/promotion/collage/platform/record/getDetail/',/* 获取拼团记录详情 */
        getLogCollageList:'/promotion/collage/platform/getLogList/',/* 操作日志列表 */
        copyCollageInfo:'/promotion/collage/platform/copyCollageInfo/',/* 复制拼团活动 */
        removeCollageInfo:'/promotion/collage/platform/removeCollageInfo/',/* 删除活动 */
        stopCollageInfo:'/promotion/collage/platform/stopCollageInfo',/* 停止活动 */
        exportNoTabApplyGoods:'/promotion/audit/platform/exportNoTabApplyGoods',/* 导出活动商品 */
        batchEditSort:'/promotion/audit/platform/batchEditSort',/* 设置商品的权重 */
        listHeadIncomeDetails:'/promotion/collage/platform/record/listHeadIncomeDetails/',/* 拼团活动详情页团长佣金明细 */
        groupexport:'/promotion/collage/platform/record/export',/* 拼团活动记录导出 */
        updateAchievementFinalRatios:'/promotion/audit/platform/updateAchievementFinalRatios',/* 配置收益比例 */
        moveCollageTab:'/promotion/audit/platform/moveCollageTab',/* 分类标签左移和右移 */
        /* **分享赚** */
        addPromotionShare:'promotion/platform/multi/addPromotion',//创建活动
        removeOnGoing:'/promotion/audit/platform/removeOnGoing',//撤出活动

        purchaseLimit:'/promotion/gift/commit/purchase/limit',//礼包品限购配置
    },
}
